<template>
  <div class="mix-grid">
    <div class="table">
      <Spin fix v-if="loading"></Spin>
      <div class="head row">
        <div
          class="col"
          v-for="(item, index) in normalColumns"
          :key="index"
          :style="{'min-width': item.minWidth ? item.minWidth + 'px' : undefined}"
        >{{item.title}}</div>
      </div>
      <div class="body">
        <div v-if="!list.length" class="empty">{{this.noDataText}}</div>
        <div class="body-item" v-for="(item, index) in list" :key="index">
          <div class="mix" v-if="mixColumns.length">
            <div class="col" v-for="(col, index) in mixColumns" :key="index">
              <span>{{col.title}}：</span>
              <span v-if="col.key">{{item[col.key]}}</span>
              <slot v-else-if="col.slot" :name="col.slot" :row="item"></slot>
            </div>
          </div>
          <div class="row" v-if="normalColumns.length">
            <div
              class="col"
              v-for="(col, index) in normalColumns"
              :key="index"
              :style="{'min-width': col.minWidth ? col.minWidth + 'px' : undefined}"
            >
              <div class="element">
                <span v-if="col.key">{{item[col.key]}}</span>
                <slot v-else-if="col.slot" :name="col.slot" :row="item"></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <div class="f-left grid-footer-left">
        <slot name="footer-left"></slot>
      </div>
      <Page
        class="f-right"
        show-total
        @on-page-size-change="onPageSizeChange"
        @on-change="onChangePage"
        :total="total"
        :current="page"
        show-elevator
        show-sizer
        transfer
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "mix-grid",
  props: {
    columns: {
      type: Array,
      default() {
        return [];
      }
    },
    dataUrl: {
      type: String,
      default: ""
    },
    search: {
      type: Object,
      defautl() {
        return {};
      }
    },
    rowsFormatter: {
      type: Function
    },
    method: {
      type: String,
      default: "get"
    },
    noDataText: {
      type: String,
      default: "暂无数据"
    }
  },
  data() {
    return {
      list: [],
      columnSpan: [],
      loading: false,
      page: 1,
      limit: 10,
      total: 0,
      mixColumns: [],
      normalColumns: []
    };
  },
  async created() {
    this.filterColumns();
    await this.requestList();
  },
  methods: {
    // on event
    async onPageSizeChange(val) {
      this.limit = val;
      await this.requestList();
    },
    async onChangePage(val) {
      this.page = val;
      await this.requestList(false);
    },
    // other
    filterColumns() {
      this.mixColumns = [];
      this.normalColumns = [];
      this.columns.forEach(i => {
        if (i.mix) this.mixColumns.push(i);
        else this.normalColumns.push(i);
      });
    },
    async refresh(reset = true) {
      await this.requestList(reset);
    },
    // request
    async requestList(reset = true) {
      if (!this.dataUrl) return;
      if (reset) this.page = 1;
      const params = {
        page: this.page,
        limit: this.limit,
        ...this.search
      };
      this.loading = true;
      let data = await this.$http[this.method](this.dataUrl, params, {
        onComplete: () => {
          this.loading = false;
        }
      });
      this.total = data.total;
      this.list = data.list;
      this.rowsFormatter && this.rowsFormatter(this.list);
      if (this.list.length == 0 && !reset && this.page > 1) {
        this.page--;
        await this.requestList(reset);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.mix-grid {
  .table {
    border: 1px solid #d8d8d8;
    font-size: 12px;
    line-height: 18px;
    overflow-x: auto;
    position: relative;
    .head {
      background-color: #eee;
      font-weight: 700;
      border-bottom: 1px solid #e8eaec;
      .col {
        border-right: 1px solid #e0e0e0 !important;
        &:last-child {
          border-right: none !important;
        }
      }
    }
    .body {
      .empty {
        text-align: center;
        padding: 15px 0;
      }
      .body-item {
        border-bottom: 1px solid #e8eaec;
        &:hover {
          background-color: #eaf5ff !important;
          .mix {
            background-color: #eaf5ff !important;
          }
        }
        &:last-child {
          border-bottom: none;
        }
      }
    }
    .row {
      display: flex;
      justify-content: space-between;
      // border-bottom: 1px solid #e8eaec;
      overflow-x: visible;
      .col {
        padding: 10px 18px;
        border-right: 1px solid #e8eaec;
        // height: 100%;
        width: 100%;
        text-align: center;
        &:last-child {
          border-right: none;
        }
        .element {
          position: relative;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
    .mix {
      display: flex;
      background-color: #f8f8f9;
      border-bottom: 1px solid #e8eaec;
      padding: 10px 18px;
      .col {
        margin-right: 50px;
      }
    }
  }
  .footer {
    padding: 10px 0;
  }
}
</style>